import React, { Component } from "react";
import history from "./../history";

class NavBar extends Component {
  render() {
    const button = this.props.buttonPath ? (
      <button
        className="skip-btn"
        onClick={() => history.push(this.props.buttonPath)}
      >
        Skip
      </button>
    ) : (
      <div />
    );

    return (
      <nav className="navbar ui-widget-header">
        <div style={{ marginLeft: "5%" }}>
          <p>
            <img
              src={process.env.PUBLIC_URL + "/ba-dap-prove-full-logo@2x.png"}
              alt="logo"
              className="BaDAPProve-Full-Logo"
            />
          </p>
          <b className="step-name">{this.props.stepName}</b>
          <p className="step-text">{this.props.stepText}</p>
        </div>
        <div style={{ marginRight: "5%" }}>
          <p className="button-text">{this.props.buttonText}</p>
          {button}
        </div>
      </nav>
    );
  }
}
export default NavBar;
